import React, { useState } from 'react';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';
import SystemsIntegrated from './components/SystemsIntegrated';
import DataRefreshHistories from './components/DataRefreshHistories';
import RefreshFrequency from './components/RefreshFrequency';
import UserSessionInfo from './components/UserSessionInfo';
import UserProfile from './components/UserProfile';
import UsersOnSystem from './components/UsersOnSystem';
import AuditLog from './components/AuditLog';

const AdministrationPanel = () => {
  const [activeTab, setActiveTab] = useState('systems');

  const tabs = [
    {
      id: 'systems',
      label: 'Systems Integrated',
      icon: 'Database',
      component: SystemsIntegrated,
    },
    {
      id: 'histories',
      label: 'Data Refresh Histories',
      icon: 'History',
      component: DataRefreshHistories,
    },
    {
      id: 'frequency',
      label: 'Refresh Frequency',
      icon: 'Clock',
      component: RefreshFrequency,
    },
    {
      id: 'sessions',
      label: 'User Session Info',
      icon: 'Activity',
      component: UserSessionInfo,
    },
    {
      id: 'profile',
      label: 'User Profile',
      icon: 'User',
      component: UserProfile,
    },
    {
      id: 'users',
      label: 'Users on System',
      icon: 'Users',
      component: UsersOnSystem,
    },
    {
      id: 'audit-logs',
      label: 'Audit Log',
      icon: 'FileText',
      component: AuditLog,
    },
  ];

  const ActiveComponent = tabs?.find((tab) => tab?.id === activeTab)?.component;

  return (
    <div className="min-h-screen bg-background pt-16">
      <Header />
      <div className="max-w-[1600px] mx-auto p-6 md:p-8 lg:p-10">
        <div className="mb-6 md:mb-8">
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground mb-2">
            Administration Panel
          </h1>
          <p className="text-sm md:text-base text-muted-foreground">
            Manage system integrations, data refresh processes, and user access
          </p>
        </div>

        <div className="bg-card border border-border rounded-md overflow-hidden">
          <div className="border-b border-border overflow-x-auto">
            <div className="flex min-w-max lg:min-w-0">
              {tabs?.map((tab) => (
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`flex items-center gap-2 px-4 md:px-6 py-3 md:py-4 font-medium text-sm md:text-base transition-smooth whitespace-nowrap ${
                    activeTab === tab?.id
                      ? 'text-primary border-b-2 border-primary bg-primary/5' :'text-muted-foreground hover:text-foreground hover:bg-muted'
                  }`}
                >
                  <Icon name={tab?.icon} size={18} />
                  <span className="hidden sm:inline">{tab?.label}</span>
                  <span className="sm:hidden">
                    {tab?.label?.split(' ')?.[0]}
                  </span>
                </button>
              ))}
            </div>
          </div>

          <div className="p-4 md:p-6 lg:p-8">
            {ActiveComponent && <ActiveComponent />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdministrationPanel;